module.exports = __webpack_public_path__ + "img/news_bg_7-7-2021.95b20e20.jpg";